import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { useEffect, useState } from 'react';

import { getChatsNotificationsMicrofrontend } from '../../../services/getChatsNotificationsMicrofrontend';
import { useApplicationContext } from '../../../utils/applicationContext';
import { checkCianMfRegistry } from '../../../utils/checkCianMfRegistry';

export const useChatsNotificationsMicrofrontend = () => {
  const context = useApplicationContext();
  const [manifest, setManifest] = useState<IMicrofrontendManifest | null>(null);

  useEffect(() => {
    const isCianMfRegistryEnabled = checkCianMfRegistry();

    if (isCianMfRegistryEnabled) {
      getChatsNotificationsMicrofrontend(context).then(setManifest);
    }
  }, [context]);

  return manifest;
};
